/**
 * AI面接練習の面接官タイプと、チャット冒頭の定型文。
 *
 * `value` はURLクエリ・DBに入る識別子、`label` はSPの短い表示、
 * `name` はAIへ渡す日本語名（プロンプトにそのまま載る）。
 */

export type InterviewerStyle = {
  value: string
  label: string
  name: string
}

export const INTERVIEWER_STYLES: InterviewerStyle[] = [
  { value: 'passionate', label: '熱血', name: '熱血な面接官' },
  { value: 'normal', label: '普通', name: '普通の面接官' },
  { value: 'pressure', label: '圧迫', name: '圧迫面接' }
]

export const DEFAULT_INTERVIEWER_STYLE = 'normal'

export const INTERVIEW_FIRST_QUESTION =
  '最初の質問です。面接の設定のため、\n\n応募したい会社\n\nをお聞かせください。\n会社名にあわせて、業界や業種・職務内容などもあるとより良い面接練習ができます。'

const findStyle = (value: unknown): InterviewerStyle | undefined =>
  INTERVIEWER_STYLES.find((item) => item.value === value)

/** 未知の値（旧データ・手打ちURL）を既定へ倒すための判定 */
export function isKnownInterviewerStyle(value: unknown): boolean {
  return !!findStyle(value)
}

/** AIへ渡す日本語名。未知なら空文字（プロンプトにスタイル指定を載せない） */
export function interviewerStyleName(value: unknown): string {
  const style = findStyle(value)
  return style ? style.name : ''
}

/** SP上部カードに出す短いラベル */
export function interviewerStyleShortLabel(value: unknown): string {
  const style = findStyle(value)
  return style ? style.label : '普通'
}

/** チャット冒頭の挨拶。面接官タイプが決まっていればそれも伝える */
export function buildInterviewGreeting(styleName: string): string {
  let message = 'こんにちは！AI面接練習(β版)へようこそ。\n\n'
  message +=
    '私はあなたの面接練習をサポートするAIヤギです。実際の面接官の役割を演じながら、様々な質問をさせていただきます。\n'
  message += styleName ? `面接官のスタイルは「${styleName}」です。\n\n` : '\n'
  message += '準備はよろしいでしょうか？それでは、面接練習を始めましょう。'
  return message
}
